export const PushNotificationType = {
  CANCELED_FROM_USER_TO_PARTNER: 'canceledFromUserToPartner',
  CANCELED_IN_CMS_TO_PARTNER: 'canceledInCmsToPartner',
  OPEN_STORES: 'openStores',
};
